import { useTranslation } from 'react-i18next';

import { cn } from 'app/adapters/cn';
import {
  THEME_SPLASH_CLASS,
  THEME_SPLASH_TEXT_CLASS,
} from 'app/constants/themeClasses';

import { Spinner } from '../Spinner';

export function SplashScreen() {
  const { t } = useTranslation();
  return (
    <div
      className={cn('az-h-screen az-w-screen', THEME_SPLASH_CLASS)}
      aria-label="Overlay"
      aria-describedby="Splash screen"
    >
      <div className="az-mx-auto az-flex az-h-screen az-flex-col az-items-center az-px-6 az-py-8 sm:az-justify-center">
        <div className="az-flex az-items-center az-space-x-2">
          <Spinner sizes="lg" />
          <h1
            className={cn(
              'az-page-title',
              THEME_SPLASH_TEXT_CLASS,
            )}
          >
            {t('Common.loadingPleaseWait')}
          </h1>
        </div>
      </div>
    </div>
  );
}
